export default __webpack_public_path__ + "images/HX.036fcae.png";